import React from "react";
import ReceiptVoucher from './Receipt_Voucher';

const RcptVchrApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Receipt Voucher</h5>
          </div>
        </div>
        <ReceiptVoucher />
      </div>
    </div >
  );
};

export default RcptVchrApp;
